import { render, staticRenderFns } from "./PostalCodes.vue?vue&type=template&id=0ba62cbe&scoped=true"
import script from "./PostalCodes.vue?vue&type=script&lang=js"
export * from "./PostalCodes.vue?vue&type=script&lang=js"
import style0 from "./PostalCodes.vue?vue&type=style&index=0&id=0ba62cbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba62cbe",
  null
  
)

export default component.exports